// extracted by mini-css-extract-plugin
module.exports = {"suggestionsContainer":"_3cnRIZ","suggestion":"YezSwJ","suggestionHighlighted":"_1PTD4I","container":"ZPGkqB"};